import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
// import edit from "../../assets/admin/edit.svg";
import axios from "axios";
import { toast } from "react-toastify";
import TableLoader from "../../../utils/TableLoader";
import { MdModeEdit } from "react-icons/md";
import RestUserRoleEdit from "./RestUserRoleEdit";

const RestUserRole = ((props, ref) => {

  const { hasPermission } = props;
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState({ main: false, edit: false, save: false });
  const [isEditing, setIsEditing] = useState(false);

  const [userRole, setUserRole] = useState({});
  const [userRoleEdit, setUserRoleEdit] = useState({});
  const [roleID, setRoleID] = useState("");
  const [roleName, setRoleName] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getUserRoleData = async () => {
    setIsLoading({ ...isLoading, main: true });
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/roles`,
        {
          params: {
            pageNumber: page,
            size: rowsPerPage,
            type: "restaurant",
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserRole(response?.data?.data);
      // console.log("getUserRoleData ~ response:", response.data.data);
    } catch (error) {
      console.error("Error fetching user role data:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const handleEditClick = async (roleID, roleName) => {
    // console.log("🚀 ~ handleEditClick ~ roleID:", roleID)
    setRoleID(roleID);
    setRoleName(roleName);
    setIsEditing(true);
    setIsLoading({ ...isLoading, edit: true });
    try {
      const response = await axios.get(`${apiUrl}/api/v1/roles/${roleID}/show-permissions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserRoleEdit(response?.data?.permissions);
    } catch (error) {
      console.error("Error fetching user role data:", error);
    } finally {
      setIsLoading({ ...isLoading, edit: false });
    }
  };

  const handleCheckboxChange = (moduleName, action, value) => {
    setUserRoleEdit((prevPermissions) =>
      prevPermissions.map((role) =>
        role.module === moduleName
          ? {
            ...role,
            actions: {
              ...role.actions,
              [action]: value,
            },
          }
          : role
      )
    );
  };

  const handleSave = async () => {
    setIsLoading({ ...isLoading, save: true });
    try {
      const response = await axios.put(
        `${apiUrl}/api/v1/roles/${roleID}/update-permissions`,
        { permissions: userRoleEdit },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success(response.data.message, { theme: "colored" });
        setUserRoleEdit(userRoleEdit);
        setIsEditing(false);
      }
    } catch (error) {
      console.error("Failed to update permissions:", error.response?.data);
    } finally {
      setIsLoading({ ...isLoading, save: false });
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  useImperativeHandle(ref, () => ({
    userRole() {
      setIsEditing(false);
    },
  }));

  useEffect(() => {
    getUserRoleData();
  }, [page, totalPages])

  return (
    <>
      {!isEditing ? (
        <section className="user-table-rol border-t border-[#D9D9D9] md:mt-5 sm:pt-10 pt-5">
          <h3 className="text-3xl font-bold mb-2 poppins-medium">Tutti i Ruoli</h3>
          <div className="overscroll-auto	 w-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b">
                  <th className="pb-3 poppins-regular text-[#6B6B6B]">Nome Ruolo</th>
                  {hasPermission("Roles", "edit") && (
                    <th className="pb-3 flex justify-end sm:mr-12 poppins-regular text-[#6B6B6B]">Opzioni</th>
                  )}
                </tr>
              </thead>
              {isLoading?.main ? (
                <TableLoader />
              ) : (
                <tbody>
                  {userRole?.length > 0 ? (
                    userRole.map((role, index) => (
                      <tr key={index} className="border-b">
                        {/* <td className="py-3 poppins-regular">{role.name || "N/A"}</td> */}
                        <td className="py-3 poppins-regular">
                          {role?.name === "Owner"
                            ? "Proprietario"
                            : role?.name === "Operator"
                              ? "Operatore"
                              : role?.name || "N/A"}
                        </td>
                        {hasPermission("Roles", "edit") && (
                          <td className="py-3 flex justify-end sm:mr-12">
                            <button
                              onClick={() => handleEditClick(role.id, role.name)}
                              className="mx-2 p-2 bg-[#D6B6BA36] border-[1px] border-[#8B24334F] rounded-md"
                            >
                              {/* <img src={edit} alt="Edit" height={10} width={10} /> */}
                              <MdModeEdit size={"20px"} color="6B6B6B"/>
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} className="text-center py-3 text-gray-500">
                        <div>
                          <img src="empty-state.svg" alt="No roles" className="mx-auto mb-3" />
                          <p>No roles found.</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </section>
      ) : (
        <RestUserRoleEdit
          isLoading={isLoading}
          roleName={roleName}
          userRoleEdit={userRoleEdit}
          handleCheckboxChange={handleCheckboxChange}
          handleSave={handleSave}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
});

export default forwardRef(RestUserRole);
